export default {
  'imm5669.familyMemberTableTitle': '家庭成员',
  'imm5669.familyMemberTableFullName': '姓名',
  'imm5669.familyMemberTableStatus': '状态',
  'imm5669.familyMemberTableStatus.missingInformation': '缺少信息',
  'imm5669.familyMemberTableStatus.complete': '完成',

  'imm5669.steps.sectionA': '个人信息',
  'imm5669.steps.sectionB': '问卷',
  'imm5669.steps.sectionC': '教育',
  'imm5669.steps.sectionD': '个人历史',
  'imm5669.steps.sectionE': '组织会员和协会',
  'imm5669.steps.sectionF': '政府职位',
  'imm5669.steps.sectionG': '军事和准军事服务',
  'imm5669.steps.sectionH': '地址',

  'imm5669.title.personal': 'A部分：个人信息',
  'imm5669.personal.fullName': '姓名',
  'imm5669.personal.dob': '出生日期（YYYY/MM/DD）',
  'imm5669.personal.deceasedDate': '死亡日期（如已故）（YYYY/MM/DD）',
  'imm5669.personal.cityOfBirth': '出生城市',
  'imm5669.personal.countryOfBirth': '出生国家或地区',

  'imm5669.personal.father.title': '父亲信息',
  'imm5669.personal.mother.title': '母亲信息',

  'imm5669.title.questionnaire': 'B部分：问卷',
  'imm5669.description.questionnaire': '您或您列出的家庭成员是否曾：',
  'imm5669.questionnaire.isConvictedInCanada':
    '1. 是否曾在加拿大被判犯罪或违法行为，且未根据加拿大犯罪记录法获得赦免？',
  'imm5669.questionnaire.isConvictedOutsideCanada':
    '2. 是否曾在其他国家或地区被判犯罪或违法行为，或目前被指控、审判中、参与犯罪或违法行为，或涉及任何刑事诉讼？',
  'imm5669.questionnaire.isClaimedRefugeeProtection':
    '3. 是否曾在加拿大或加拿大签证办公室、其他国家或地区、或联合国难民事务高级专员公署（UNHCR）提出过难民保护申请？',
  'imm5669.questionnaire.isRefusedRefugeeOrVisa':
    '4. 是否曾被拒绝难民身份、移民或永久居民签证（包括魁北克选择证书[CSQ]或省提名计划申请）或访客或临时居民签证，加拿大或其他国家或地区？',
  'imm5669.questionnaire.isOrderedToLeaveCountry':
    '5. 是否曾被拒绝入境或被命令离开加拿大或其他国家或地区？',
  'imm5669.questionnaire.isWarCriminal':
    '6. 是否曾参与种族灭绝、战争罪或反人类罪行？',
  'imm5669.questionnaire.isCommittedActOfViolence':
    '7. 是否曾使用、计划或倡导使用武装斗争或暴力以实现政治、宗教或社会目标？',
  'imm5669.questionnaire.isAssociatedWithViolentGroup':
    '8. 是否曾与使用、使用过或倡导使用武装斗争或暴力以实现政治、宗教或社会目标的团体有联系？',
  'imm5669.questionnaire.isMemberOfCriminalOrg':
    '9. 是否曾是从事犯罪活动的组织的成员？',
  'imm5669.questionnaire.isDetainedOrJailed': '10. 是否曾被拘留、监禁或入狱？',
  'imm5669.questionnaire.isPhysicalOrMentalDisorder':
    '11. 是否曾患有严重疾病或身体或精神障碍？',
  'imm5669.questionnaire.additionalDetails':
    '如果您对任何问题的回答是肯定的，请在下方提供详细信息（最多679个字符）：',

  'imm5669.title.education': 'C部分：教育',
  'imm5669.education.overallTitle':
    '请提供您在以下各级教育中成功完成的学年数：',
  'imm5669.education.elementarySchoolYears': '小学',
  'imm5669.education.secondarySchoolYears': '中学',
  'imm5669.education.universityAndCollegeYears': '大学/学院',
  'imm5669.education.otherSchoolYears': '职业学校或其他高等教育',

  'imm5669.education.educationHistory.fullDetailsTitle':
    '请提供您所有中学和高等教育（包括大学、学院和学徒培训）的详细信息。',
  'imm5669.title.formList.educationHistory': '教育 #',
  'imm5669.education.educationHistory.from': '从（YYYY-MM）',
  'imm5669.education.educationHistory.to': '到（YYYY-MM）',
  'imm5669.education.educationHistory.nameOfInstitution': '机构名称',
  'imm5669.education.educationHistory.cityAndCountry': '城市和国家/地区',
  'imm5669.education.educationHistory.typeOfDiploma': '颁发的证书或文凭类型',
  'imm5669.education.educationHistory.fieldOfStudy': '学习领域',

  'imm5669.title.personalHistory': 'D部分：个人历史',
  'imm5669.description.personalHistory':
    '请提供您过去10年的个人历史，或自您18岁生日以来的个人历史（如果少于10年）。从最近的信息开始。在"活动"下，写下您的职业或职位。如果您没有工作，请提供您在做什么的信息（例如，失业、学习、旅行、退休、被拘留）。如果您在国籍所在国家或地区之外，请注明您在所在国家或地区的身份。注意：请确保时间上没有空白。',
  'imm5669.title.formList.personalHistory': '个人历史 #',
  'imm5669.personalHistory.from': '从（YYYY-MM）',
  'imm5669.personalHistory.to': '到（YYYY-MM）',
  'imm5669.personalHistory.activity':
    '活动（例如，工作 - 公司名称和职位，失业，教育）',
  'imm5669.personalHistory.cityAndCountry': '城市和国家/地区',
  'imm5669.personalHistory.status':
    '在国家或地区的身份（例如，工作许可，公民，学生许可，访客许可）',
  'imm5669.personalHistory.nameOfEmployerOrSchool':
    '公司、雇主、学校、设施名称（如适用）',

  'imm5669.title.memberships': 'E部分：组织会员和协会',
  'imm5669.description.memberships':
    '您支持、成为会员或与哪些组织有联系？包括任何政治、社会、青年或学生组织、工会和专业协会。请勿使用缩写。注明您成为会员的城市和国家或地区。如果您没有加入任何协会/组织，请在第一个输入字段中写"无"。',
  'imm5669.title.formList.memberships': '会员 #',
  'imm5669.memberships.from': '从（YYYY-MM）',
  'imm5669.memberships.to': '到（YYYY-MM）',
  'imm5669.memberships.nameOfOrganization': '组织名称',
  'imm5669.memberships.typeOfOrganization': '组织类型',
  'imm5669.memberships.activities': '在组织中的活动和/或职位',
  'imm5669.memberships.cityAndCountry': '城市和国家/地区',

  'imm5669.title.governmentPositions': 'F部分：政府职位',
  'imm5669.description.governmentPositions':
    '列出您曾担任的任何政府职位（如公务员、法官、警察、安保组织员工）。包括您退休前后的职位。请勿使用缩写。如果您没有担任任何政府职位，请在第一个输入字段中写"无"。',
  'imm5669.title.formList.governmentPositions': '政府职位 #',
  'imm5669.governmentPositions.from': '从（YYYY-MM）',
  'imm5669.governmentPositions.to': '到（YYYY-MM）',
  'imm5669.governmentPositions.cityAndCountry':
    '国家/地区和管辖级别（国家、地区、市级）',
  'imm5669.governmentPositions.department': '部门/分支',
  'imm5669.governmentPositions.activities': '活动和/或职位',

  'imm5669.title.militaryPositions': 'G部分：军事和准军事服务',
  'imm5669.description.militaryPositions':
    '请提供您在所服务国家的武装部队中的军事和准军事服务的完整详细信息。如果您没有进行过军事和/或准军事服务，请在第一个输入字段中写"无"。注意：请确保时间上没有空白。',
  'imm5669.title.formList.militaryPositions': '军事和准军事服务 #',
  'imm5669.militaryPositions.country': '国家或地区名称',
  'imm5669.militaryPositions.branchOfService': '服务分支、单位编号和指挥官姓名',
  'imm5669.militaryPositions.from': '从（YYYY-MM）',
  'imm5669.militaryPositions.to': '到（YYYY-MM）',
  'imm5669.militaryPositions.rank': '军衔',
  'imm5669.militaryPositions.reasonsEndService': '服务结束原因',
  'imm5669.militaryPositions.combatDetails': '任何战斗的日期和地点',

  'imm5669.title.addresses': 'H部分：地址',
  'imm5669.description.addresses':
    '列出您在过去10年中居住过的所有地址，或自您18岁生日以来的地址（如果少于10年）。请勿使用邮政信箱地址。',
  'imm5669.title.formList.addresses': '地址 #',
  'imm5669.addresses.from': '从（YYYY-MM）',
  'imm5669.addresses.to': '到（YYYY-MM）',
  'imm5669.addresses.street': '街道和门牌号',
  'imm5669.addresses.city': '城市或城镇',
  'imm5669.addresses.provinceOrState': '省、州或地区',
  'imm5669.addresses.country': '国家或地区',
  'imm5669.addresses.postalCode': '邮政编码或邮政区号',
};
